/** หกชีพจร (lane C4 skeleton): azure + ink, motif rays. Built from swordKit via families/handArtGen.ts; polish later. */
import { makeHandArt } from '../families/handArtGen';

export const SIXPULSE_FX: ReturnType<typeof makeHandArt> = makeHandArt('pulse-seal', { a: 'azure', b: 'ink', motif: 'rays' }, [
  ['sf-finger', 'throw', 3],
  ['sf-pulse', 'fist'],
  ['sf-six', 'throw', 8],
  ['sf-hold', 'grab'],
  ['sf-qin', 'throw', 6],
  ['sf-drift', 'buff'],
  ['sf-water', 'heal'],
  ['sf-divine', 'power', 7],
]);
